/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, RoutePath } from "../../../utility/Constant";

const WorkforceUniquePage = () => {
  const { workforceApi } = apiPath;
  const [workforceUniqueData, workforceUniqueLoading] = useFetch(workforceApi);
  const [filteredData, setFilteredData] = useState();
  let { id } = useParams();
  const { servicesWorkforceList } = RoutePath


  useEffect(() => {
    setFilteredData(workforceUniqueData?.filter((item) => item._id === id)[0]);
  }, [workforceUniqueData, id]);

  if (workforceUniqueLoading || !filteredData?._id) {
    return <Loading />;
  }

  const {
    Banner_image,
    Content_Image,
    Content_Image2,
    Banner_Title,
    Banner_Description,
    Content_Title,
    Para_Title,
    Para_Desc_1,
    Para_Desc_2,
    service_detail_list,
    _id,
  } = filteredData ?? {};

  // const data = [
  //   {
  //     elementType: "input",
  //     label: "Banner Title",
  //     type: "Text",
  //     name: "Banner_Title",
  //     defaultValue: Banner_Title,
  //     required: false,
  //   },
  //   {
  //     elementType: "input",
  //     label: "Content Title",
  //     type: "Text",
  //     name: "Content_Title",
  //     defaultValue: Content_Title,
  //     required: false,
  //   },
  //   {
  //     elementType: "input",
  //     label: "Para Title",
  //     type: "Text",
  //     name: "Para_Title",
  //     defaultValue: Para_Title,
  //     required: false,
  //   },
  //   {
  //     elementType: "textField",
  //     label: "Para description 1",
  //     type: "Text",
  //     name: "Para_Desc_1",
  //     defaultValue: Para_Desc_1,
  //     required: false,
  //   },
  //   {
  //     elementType: "textField",
  //     label: "Para description 2",
  //     type: "Text",
  //     name: "Para_Desc_2",
  //     defaultValue: Para_Desc_2,
  //     required: false,
  //   },
  //   {
  //     elementType: "textField",
  //     label: "Banner description",
  //     type: "Text",
  //     name: "Banner_Description",
  //     defaultValue: Banner_Description,
  //     required: false,
  //   },
  //   {
  //     elementType: "textField",
  //     label: "service detail list",
  //     type: "Text",
  //     name: "service_detail_list",
  //     defaultValue: service_detail_list,
  //     required: false,
  //   },
  //   {
  //     elementType: "file",
  //     label: `Content Image`,
  //     name: "Content_Image",
  //     type: "file",
  //     fullCol: true,
  //     defaultValue: Content_Image,
  //     required: false,
  //   },
  //   {
  //     elementType: "file",
  //     label: `Content Image 2`,
  //     name: "Content_Image2",
  //     type: "file",
  //     fullCol: true,
  //     defaultValue: Content_Image2,
  //     required: false,
  //   },
  //   {
  //     elementType: "file",
  //     label: `Banner Image`,
  //     name: "Banner_image",
  //     type: "file",
  //     fullCol: true,
  //     defaultValue: Banner_image,
  //     required: false,
  //   },
  // ];
  const data = [
    // # 1
    {
      elementType: "input",
      label: "Workforce Title",
      type: "Text",
      name: "Content_Title",
      defaultValue: Content_Title,
      required: false,
    },
    // # 2 
    {
      elementType: "file",
      label: `Workforce Thumbnail`,
      name: "Content_Image",
      type: "file",
      fullCol: true,
      defaultValue: Content_Image,
      required: false,
    },
    // # 3
    {
      elementType: "file",
      label: `Workforce Banner`,
      name: "Banner_image",
      type: "file",
      fullCol: true,
      defaultValue: Banner_image,
      required: false,
    },
    // #4 
    {
      elementType: "input",
      label: "Banner Title",
      type: "Text",
      name: "Banner_Title",
      defaultValue: Banner_Title,
      required: false,
    },
    // # 5
    {
      elementType: "textField",
      label: "Banner description",
      type: "Text",
      name: "Banner_Description",
      defaultValue: Banner_Description,
      required: false,
    },
    // # 6 
    {
      elementType: "richTextEditor",
      label: "Service Details",
      type: "richTextEditor",
      name: "service_detail_list",
      defaultValue: service_detail_list,
      required: false,
    },
  ];

  const update = (data) => {
    const { Banner_image, Content_Image, Content_Image2, ...rest } = data;
    if (Banner_image) {
      rest.Banner_image = {
        url: Banner_image,
      };
    }
    if (Content_Image) {
      rest.Content_Image = {
        url: Content_Image,
      };
    }
    if (Content_Image2) {
      rest.Content_Image2 = {
        url: Content_Image2,
      };
    }
    updateData(workforceApi, rest, _id);
    setTimeout(() => {
      window.location.href = "/" + servicesWorkforceList;
    }, 800);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default WorkforceUniquePage;
